export default __webpack_public_path__ + "static/media/empty-questions-list.990bebc3.png";